import { CommonModule } from '@angular/common';
import { MatchesRoutingModule } from './matches-routing.module';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatchDetailsComponent } from './match-details/pages/match-details/match-details.component';
import { MatchesListComponent } from './matches-list/matches-list.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatchCardComponent } from './match-card/match-card.component';
import { ChooseYourTeamDialogComponent } from './match-details/components/choose-your-team-dialog/choose-your-team-dialog.component';
import { SportValidateComponent } from './sport-validate/sport-validate.component';
import { SportOrderItemComponent } from './sport-order-item/sport-order-item.component';
import { MatchHeaderComponent } from './shared/match-header/match-header.component';

@NgModule({
  declarations: [
    MatchesListComponent,
    MatchCardComponent,
    MatchDetailsComponent,
    ChooseYourTeamDialogComponent,
    SportValidateComponent,
    SportOrderItemComponent,
  ],
  imports: [
    SharedModule,
    MatchesRoutingModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
  ],
})
export class MatchesModule {}
